export default __webpack_public_path__ + "203ae4681b28ebf0722716c074b1cee4.svg";